export const isLeftBorderExceeded = (offset: number): boolean => {
    return offset > 0;
}

export const isRightBorderExceeded = (offset: number, totalSize: number, slideSize: number, threshold: number) => {
    return Math.abs(offset) >= totalSize - slideSize + threshold;
}

export const notCrossingLeftBorder = (offset: number, threshold = 0): boolean => {
    return offset - threshold <= 0
}

export const notCrossingRightBorder = (offset: number, totalSize: number, slideSize: number, threshold = 0) => {
    return offset >= -(totalSize - slideSize + threshold);
}
